const img = require('./Right Hand Inswing.svg'); export default img;